<template>
  <v-card :style="{ 'min-height': `${height}px`}" :class="['d-flex', 'flex-grow-1', { 'primary': dark}, {'darken-4' : dark}]" :dark="dark">
    
    <div class="d-flex flex-column flex-grow-1">
      <v-card-title>
        {{ label }}
      </v-card-title>      
      <apexchart
        class="mb-3"
        type="bar"
        :height="chartHeight"
        :options="chartOptions"
        :series="cseries"
      ></apexchart>
    </div>
  </v-card>
</template>

<script>
import Formatters from '@/mixins/formatters'


export default {
  components: {
  },
  mixins: [Formatters],
  props: {
    series: {
      type: Array,
      default: () => [10,19,28,36,45,54,63,80]
    },
    xaxis: {
      type: Array,
      default: () => ([
          '2018-09-19T00:00:00.000Z',
          '2018-09-20T00:00:00.000Z',
          '2018-09-21T00:00:00.000Z',
          '2018-09-22T00:00:00.000Z',
          '2018-09-23T00:00:00.000Z',
          '2018-09-24T00:00:00.000Z',
          '2018-09-25T00:00:00.000Z'
        ])
    },
    label: {
      type: String,
      default: 'Sales'
    },
    options: {
      type: Object,
      default: () => ({})
    },
    dark: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 200
    },
    chartHeight: {
      type: Number,
      default: 200
    },
  },
  computed: {
    cseries() {
      return [{
        name: this.$t('campaigns.segment.swu.chart.yaxis'),
        data: this.series
      }]
    },
    chartOptions() {
      //let t = this;
      const primaryColor = this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark.primary
        : this.$vuetify.theme.themes.light.primary
      const secondaryColor = this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark.success
        : this.$vuetify.theme.themes.light.success
      return {
        chart: {
          height: this.chartHeight,
          sparkline: {
            enabled: !true
          },
          toolbar: {
            show: false
          },
          animations: {
            speed: 400
          }
        },
        colors: [primaryColor, secondaryColor],
        fill: {
          type: 'solid',
          colors: [primaryColor, secondaryColor],
          opacity: 0.15
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        xaxis: { 
            type: 'datetime', 
            categories: this.xaxis, 
            labels: {
                show: true,
                rotate: -45,
                rotateAlways: !true,
                hideOverlappingLabels: !false,
                style: {
                  fontFamily: 'Quicksand, sans-serif'
                },
                datetimeFormatter: {
                  year: this.$t('campaigns.segment.swu.chart.dateFormat'),
                  month: this.$t('campaigns.segment.swu.chart.dateFormat'),
                  day: this.$t('campaigns.segment.swu.chart.dateFormat'),
                  //hour: 'HH:mm',
          },
            },
            position: 'top',
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
            
            crosshairs: {
              fill: {
                type: 'gradient',
                gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
            
          },
          
         /*
          tooltip: {
            enabled: true,
          }
          */
        },
        //yaxis: this.series.map(s => {return { title: { text: s.title }, show: false }}),
        //yaxis: t.series.map(s => { return { seriesName: s.name, min: 0, max: (n) => n + Math.pow(10,(Math.log10(n) - 1)), show: false }}),
        
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val;
            }
          }
        
        },
        grid: { show: false },
       
        tooltip: {
          followCursor: true,
          theme: this.dark ? 'dark' : 'light',
          style: {
            fontFamily: 'Quicksand, sans-serif'
          },
          
          x: {
            format: this.$t('campaigns.segment.swu.chart.dateFormat')//'d.M.yyyy',
          }
          
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        
        
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val;
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            fontFamily: 'Quicksand, sans-serif',
            colors: ["#304758"]
          }
        },
        
        title: {
          text: this.$t('campaigns.segment.swu.chart.description'),
          floating: true,
          offsetY: this.chartHeight - 20,
          align: 'center',
          style: {
            color: '#444',
            fontFamily: 'Quicksand, sans-serif',
          }
        },
        
        ...this.options
      }
    }
  },
  methods: {
  }
}
</script>
